import { render, staticRenderFns } from "./labelCom.vue?vue&type=template&id=1177ddb7"
import script from "./labelCom.vue?vue&type=script&lang=js"
export * from "./labelCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports